import BackTo3DModelButton, {
    BackTo3DModelButtonComponent,
} from './BackTo3DModelButton'

export default BackTo3DModelButton
export { BackTo3DModelButtonComponent }
